<template>
  <div class="logistics-page">
    <a-card :bordered="false" title="物流查询帐户" :headStyle="{fontSize:'18px'}">
      <div class="content-box">
        <div class="purchase-box">
          <span class="query-number">可查询数量:{{ logisticsNumber }}条</span>
          <a-select
            v-model="typeId"
            @change="onChangeSelected"
            style="width:200px;margin: 0 20px"
            placeholder="请选择购买类型">
            <a-select-option
              v-for="(item,index) in priceList"
              :key="index"
              :value="item.id">
              {{ item.key }}次 / {{ item.value }}元
            </a-select-option>
          </a-select>
          <a-button type="primary" @click="onRecharge">立即购买</a-button>
        </div>
        <a-button type="primary" @click="showSetting">设置</a-button>
        <!--        <div class="kuai-di-100">服务技术支持：<a href="https://api.kuaidi100.com/" target="_blank"><img src="../../../assets/images/logo-100.png" alt=""></a></div>-->
      </div>
    </a-card>
    <a-card :bordered="false" style="margin-top: 20px">
      <custom-page-table
        ref="table"
        :queryParams="queryParams"
        :columns="columns"
        :requestPromise="loadPromise"
        :pageSize="20"
      >
      <span slot="index" slot-scope="rowItem">
        {{ rowItem.index + 1 }}
      </span>
      </custom-page-table>
    </a-card>
    <a-modal title="微信支付" :footer="null" :visible="rechargeVisible" @cancel="handleRechargeCancel">
      <a-radio-group v-model="payType">
        <a-radio v-for="(item,index) in payTypeList" :key="index" :value="item.id">{{ item.payWay }}</a-radio>
      </a-radio-group>
      <div v-if="payType" style="margin: 0 auto;border: 1px solid #444444;width: 202px;margin-top:20px;">
        <img :src="erWeiMaImageSrc" style="width: 200px;height: 200px;" alt="" loading="lazy">
        <div style="text-align: center;width: 200px;">{{ getPayName(payType) }}扫一扫，完成支付</div>
      </div>
    </a-modal>
    <a-modal
      title="物流设置"
      :visible="settingVisible"
      @cancel="handleSettingCancel"
      @ok="saveSetting"
    >
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :label-col="currentDialogLayout.labelCol"
        :wrapper-col="currentDialogLayout.wrapperCol"
      >
        <a-form-model-item label="自动显示分销订单物流信息">
          <a-radio-group v-model="distributionStatus">
            <a-radio :value="0">关闭</a-radio>
            <a-radio :value="1">开启</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <div>
          说明：该开关只针对分销订单有效，开启后，供应商帐户无物流查询数量时，发货上传物流信息后，将从您帐户扣除查询数物流次数。
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'LogisticsPurchasing',
  data() {
    return {
      logisticsNumber: 0,
      typeId: undefined,
      priceList: [],
      selectedIndex: 0,
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '来源渠道',
          dataIndex: 'platformName'
        },
        {
          title: '所属运营商',
          dataIndex: 'merchantName'
        },
        {
          title: '联系人',
          dataIndex: 'merchantContact'
        },
        {
          title: '联系人电话',
          dataIndex: 'merchantPhone'
        },
        {
          title: '金额',
          dataIndex: 'buyMoney'
        },
        {
          title: '查询条数',
          dataIndex: 'buyCount'
        },
        {
          title: '充值时间',
          dataIndex: 'gmtCreate'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      loadPromise: params => this.getListPromise(params),
      rechargeVisible: false,
      payTypeList: {},
      payType: 1,
      erWeiMaImageSrc: '',
      settingVisible: false,
      currentDialogLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 14 }
      },
      ruleForm: {},
      distributionStatus: 0
    }
  },
  watch: {
    rechargeVisible(val) {
      if (!val) {
        this.rechargeNo = ''
      }
    }
  },
  mounted() {
    this.getLogisticsNumber()
    this.getSysPrice()
    this.getPayTypeInfo()
  },
  methods: {
    saveSetting() {
      let params = {
        status: this.distributionStatus,
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('/express/sale/status', params)
        .then(res => {
          this.$message.success('保存成功')
          this.settingVisible = false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getSettingStatus() {
      let url = 'express/provide/status/' + this.merchantId + '/' + this.platformId
      this.getHttpServices().getServerApiService().get(url)
        .then(res => {
          this.distributionStatus = res.status ? res.status : 0
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSettingCancel() {
      this.settingVisible = false
    },
    showSetting() {
      this.getSettingStatus()
      this.settingVisible = true
    },
    onRecharge() {
      this.erWeiMaImageSrc = ''
      if (!this.typeId) {
        this.$message.warning('请选择购买类型')
        return false
      }
      this.createRechargeSmsNumOrder()
    },
    getSysPrice() {
      this.getHttpServices().getServerApiService().post('express/query/enum')
        .then(res => {
          this.priceList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getPayTypeInfo() {
      this.getHttpServices().getSmsApiService().post('base/sms/getPayWay')
        .then(res => {
          this.payTypeList = res
          this.getLogUtils().logWithTag('支付类型', res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    createRechargeSmsNumOrder() {
      this.getHttpServices().getServerApiService().post('express/create/order', {
        merchantId: this.merchantId,
        platformId: this.getPlatformConfig().platformId,
        typeId: this.typeId
      }).then(res => {
        this.rechargeVisible = true
        this.rechargeNo = res.orderNo
        this.getPayImage(res.orderNo)
        this.rechargeSmsNumIsOk(res.orderNo)
        this.getLogUtils().logWithTag('获取支付订单号-------------', res.orderNo)
      }).catch(err => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    getLogisticsNumber() {
      let url = '/express/query/' + this.merchantId + '/' + this.getPlatformConfig().platformId
      this.getHttpServices().getServerApiService().get(url)
        .then(res => {
          this.logisticsNumber = res.remainCount
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 图片示例
    rechargeSmsNumIsOk(rechargeNo) {
      if (!rechargeNo) {
        return
      }
      let url = 'express/query/orderNo?orderNo=' + rechargeNo
      this.getHttpServices().getServerApiService().get(url)
        .then(res => {
          if (res && res.result) {
            this.erWeiMaImageSrc = ''
            this.rechargeVisible = false
            this.$message.success('成功购买')
            this.getLogisticsNumber()
            this.$refs.table.refresh(true)
            this.rechargeNo = null
          } else {
            setTimeout(() => {
              this.rechargeSmsNumIsOk(this.rechargeNo)
            }, 1000)
          }
        }).catch(err => {
        this.getLogUtils().logWithTag(err)
      })
    },
    //获取支付二维码图片
    getPayImage(orderId) {
      let url = '/express/create/qrcode?orderNo=' + orderId
      this.erWeiMaImageSrc = this.getAppConfig().serviceUrl + url
      // this.getLogUtils().errorWithTag('serviceUrl',this.getAppConfig().serviceUrl)
      // this.getLogUtils().logWithTag(this.erWeiMaImageSrc)
    },
    getPayName: function(type) {
      const list = this.payTypeList
      if (list) {
        for (let i = 0, len = list.length; i < len; i++) {
          if (type == list[i].id) {
            return list[i].payWay
          }
        }
      }
      return ''
    },
    handleRechargeCancel() {
      this.rechargeVisible = false
    },
    getListPromise(params) {
      return this.getHttpServices().getServerApiService().post('express/merchant/query/list', params)
    },
    onChangeSelected(e) {
    },
    selectedBox(item, index) {
      this.selectedIndex = index
    }
  }
}
</script>

<style lang="less">
.content-box {
  display: flex;

  justify-content: space-between;
  align-items: center;

  .kuai-di-100 {
    img {
      height: 18px;
    }
  }
}
</style>